/* Router Configuration */
import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useUiStore } from '@/stores/ui'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('@/views/DashboardView.vue'),
    meta: { requiresAuth: true, title: 'Panel de Control' },
  },
  {
    path: '/devices',
    name: 'Devices',
    component: () => import('@/views/DevicesView.vue'),
    meta: { requiresAuth: true, title: 'Dispositivos' },
  },
  {
    path: '/devices/:id',
    name: 'DeviceDetail',
    component: () => import('@/views/DeviceDetailView.vue'),
    meta: { requiresAuth: true, title: 'Detalle del Dispositivo' },
  },
  {
    path: '/devices/:id/config',
    name: 'DeviceConfig',
    component: () => import('@/views/ConfigView.vue'),
    meta: { requiresAuth: true, title: 'Configuración del Dispositivo' },
  },
  {
    path: '/history',
    name: 'History',
    component: () => import('@/views/HistoryView.vue'),
    meta: { requiresAuth: true, title: 'Historial' },
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('@/views/SettingsView.vue'),
    meta: { requiresAuth: true, title: 'Configuración' },
  },
  {
    path: '/toast-demo',
    name: 'ToastDemo',
    component: () => import('@/views/ToastDemoView.vue'),
    meta: { guestOnly: true, title: 'Toast Demo' },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/LoginView.vue'),
    meta: { guestOnly: true, title: 'Iniciar Sesión' },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/RegisterView.vue'),
    meta: { guestOnly: true, title: 'Registrarse' },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()
  const uiStore = useUiStore()

  // Set page title
  if (to.meta.title) {
    uiStore.setPageTitle(to.meta.title as string)
  }

  // Initialize auth if not done
  if (!authStore.token && localStorage.getItem('auth_token')) {
    await authStore.initAuth()
  }

  // Check if route requires auth
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next({ name: 'Login', query: { redirect: to.fullPath } })
    return
  }

  // Check if route is guest only
  if (to.meta.guestOnly && authStore.isAuthenticated) {
    next({ name: 'Dashboard' })
    return
  }

  // Try to validate token on protected routes
  if (to.meta.requiresAuth && authStore.token && !authStore.user) {
    const valid = await authStore.fetchMe()
    if (!valid) {
      next({ name: 'Login', query: { redirect: to.fullPath } })
      return
    }
  }

  next()
})

export default router